export * from '@primeuix/themes/lara/autocomplete';
export { default } from '@primeuix/themes/lara/autocomplete';
